<ng-content></ng-content>
<plc-icon [name]="'link'" [size]="'s'" [hover]="true" />
